import { render, staticRenderFns } from "./DetailPageLayout.vue?vue&type=template&id=26a3e60e&"
import script from "./DetailPageLayout.vue?vue&type=script&lang=js&"
export * from "./DetailPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./DetailPageLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports